import { styles } from "@routes/InvestmentPriorityRoute/styles";

const STROKE = "#FFAC7D";
const FILL = "#FFAC7D";

export const MaximumChart = () => {
  return (
    <svg
      width="157"
      height="66"
      viewBox="0 0 157 66"
      fill="none"
      aria-hidden="true"
      style={styles.chart}
    >
      <defs>
        <linearGradient
          id="max-mask-grad"
          x1="78.5"
          y1="47.25"
          x2="0"
          y2="47.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={FILL} />
          <stop stopColor={FILL} offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="max-fill-grad"
          x1="79"
          y1="-25.2885"
          x2="79"
          y2="66.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={STROKE} />
          <stop offset="1" stopColor={STROKE} stopOpacity="0" />
        </linearGradient>
        <mask id="max-mask" maskUnits="userSpaceOnUse" x="0" y="0" width="157" height="66">
          <path d="M0 0H157V56C157 61.5229 152.523 66 147 66H0V0Z" fill="url(#max-mask-grad)" />
        </mask>
      </defs>
      <g mask="url(#max-mask)">
        <path
          d="M0 62.7671C2.79422 62.7671 3.70444 49.9455 5.06977 49.9455C6.4351 49.9455 9 56.0393 11.9024 56.0393C13.1626 56.0393 14.6271 59.2481 17.8129 59.2481C19.5 59.2481 21.5 46.5782 23.8048 48.1594C26.1097 49.7405 27.4539 50.107 29.9151 50.107C32.3764 50.107 34.0728 48.5032 35.7073 48.5032C37.3417 48.5032 38.7479 43.8826 41.5188 43.8826C44.2897 43.8826 47.3692 56.5782 48.5199 56.5782C49.6706 56.5782 51.491 40.5714 53.7666 40.5714C55.587 40.5714 58.7716 38.3041 60.5121 38.3041C64.4372 38.3041 67.0684 24.7604 69.5511 24.7604C72.0338 24.7604 71.6118 38.7919 73.8874 38.7919C76.1629 38.7919 77 31.5782 79.3169 31.5983C81.6339 31.6184 82.2054 36.5911 84.6455 36.5911C87.0856 36.5911 87.6455 26.7604 91.5 29.6045C94 32.1045 93.7243 22.2943 95.2194 22.2943C97.9614 22.2943 97.9591 27.5581 100.677 27.5581C102.965 27.5581 102.918 38.5408 105.301 38.5408C107.684 38.5408 108.585 53.1821 111.192 53.1821C113.798 53.1821 114 41.5 117.161 40.8633C120.322 40.2266 121.625 26.0976 123.9 26.0976C126.176 26.0976 127.662 48.0393 129.153 48.0393C129.963 48.0393 134.257 19.2887 136.415 21.2464C138.574 23.2042 139.515 29.2752 140.919 29.2752C142.322 29.2752 143.186 20.1218 144.913 20.1218C146.639 20.1218 147.5 12.5634 149.551 12.5634C151.602 12.5634 152.667 15.1519 153.807 12.8577C154.946 10.5636 158 2 158 2"
          stroke={STROKE}
          strokeWidth="2"
        />
        <path
          d="M69.5511 24.7604C67.0684 24.7604 64.4372 38.3041 60.5121 38.3041C58.7716 38.3041 55.587 40.5714 53.7666 40.5714C51.491 40.5714 49.6706 56.5782 48.5199 56.5782C47.3692 56.5782 44.2897 43.8826 41.5188 43.8826C38.7479 43.8826 37.3417 48.5032 35.7073 48.5032C34.0728 48.5032 32.3764 50.107 29.9151 50.107C27.4539 50.107 26.1097 49.7405 23.8048 48.1594C21.5 46.5782 19.5 59.2481 17.8129 59.2481C14.6271 59.2481 13.1626 56.0393 11.9024 56.0393C9 56.0393 6.4351 49.9455 5.06977 49.9455C3.70444 49.9455 2.79422 62.7671 0 62.7671V66.5H158V2C158 2 154.946 10.5636 153.807 12.8577C152.667 15.1519 151.602 12.5634 149.551 12.5634C147.5 12.5634 146.639 20.1218 144.913 20.1218C143.186 20.1218 142.322 29.2752 140.919 29.2752C139.515 29.2752 138.574 23.2042 136.415 21.2464C134.257 19.2887 129.963 48.0393 129.153 48.0393C127.662 48.0393 126.176 26.0976 123.9 26.0976C121.625 26.0976 120.322 40.2266 117.161 40.8633C114 41.5 113.798 53.1821 111.192 53.1821C108.585 53.1821 107.684 38.5408 105.301 38.5408C102.918 38.5408 102.965 27.5581 100.677 27.5581C97.9591 27.5581 97.9614 22.2943 95.2194 22.2943C93.7243 22.2943 94 32.1045 91.5 29.6045C87.6455 26.7604 87.0856 36.5911 84.6455 36.5911C82.2054 36.5911 81.6339 31.6184 79.3169 31.5983C77 31.5782 76.1629 38.7919 73.8874 38.7919C71.6118 38.7919 72.0338 24.7604 69.5511 24.7604Z"
          fill="url(#max-fill-grad)"
        />
      </g>
    </svg>
  );
};
